import * as Yup from 'yup';

export const AccountDetailsValidationSchema = Yup.object({
    country: Yup.string()
        .required('Country / Region is required'),
    fullname: Yup.string()
        .required('Full Name is required'),
    mobileNumber: Yup.number()
        .required('Mobile Number is required')
        .test('len', 'Mobile Number must be exactly 10 digits',
            (val) => val && val.toString().length === 10),
    address: Yup.string()
        .required('Address is required'),
    area: Yup.string(),
    pinCode: Yup.number()
        .typeError('Pin Code must be a number')
        .required('Pin Code is required')
        .test('len', 'Pin Code must be exactly 6 digits',
            (val) => val && val.toString().length === 6),
    landmark: Yup.string(),
    city: Yup.string()
        .required('Town / City is required'),
    state: Yup.string()
        .required('State is required'),
});
